import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import MoreInfoBar from '../MoreInfoBar/MoreInfoBar';

const UnitatEspecialitzadaView = (props) => {
  const { content } = props;

  return (
    <>
      <Helmet>
        <title>{content.title}</title>
        {content.description ? (
          <meta name="description" content={content.description} />
        ) : null}
        {content['@id'] ? (
          <link rel="canonical" href={flattenToAppURL(content['@id'])} />
        ) : null}
      </Helmet>
      <Container
        id="page-document"
        className="unitat-especialitzada-item document-view"
      >
        <h1 className="csj-heading1">{content.title}</h1>
        <RenderBlocks {...props} content={content} />
      </Container>
      <MoreInfoBar />
    </>
  );
};

UnitatEspecialitzadaView.propTypes = {
  content: PropTypes.shape({
    '@id': PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default UnitatEspecialitzadaView;
